import React from 'react';
import cx from './cx';

export const APP_BADGE_VARIANT_CLASS = {
  primary: 'bg-primary-100 text-primary-600',
  success: 'bg-success-100 text-success-600',
  secondary: 'bg-secondary-subtle text-secondary',
  danger: 'bg-danger-100 text-danger-600',
  info: 'bg-info-100 text-info-600',
  warning: 'bg-warning-100 text-warning-600',
  neutral: 'bg-neutral-200 text-secondary-light',
};

const AppBadge = ({
  variant = 'neutral',
  className = '',
  as: Component = 'span',
  pill = false,
  children,
  ...rest
}) => (
  <Component
    className={cx(
      'badge',
      pill && 'rounded-pill',
      variant === 'none' ? '' : (APP_BADGE_VARIANT_CLASS[variant] || APP_BADGE_VARIANT_CLASS.neutral),
      className,
    )}
    {...rest}
  >
    {children}
  </Component>
);

export default AppBadge;
